<script>
import {productClient as columns} from '../../../tables'

export default {
  name: "product-client-list",
  props: {
    product: {
      type: String,
      required: true
    }
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    },
  },
  data() {
    return {
      columns,
      productDetail: {},
      loading: false,
      items: {},
      filters: {
        page: 1,
        per_page: 10
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    getProduct() {
      this.$http.get(this.routeUri('hyperion.product.show', {
        product_hash: this.product
      })).then(res => (this.productDetail = res.data))
        .catch(err => this.handleXhrError(err))
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product.client', {
        product_hash: this.product
      }), { params: this.filters }).then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    loss (margin) {
      return margin < 0
    }
  }
}
</script>

<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-table :data-source="items.data"
               :columns="columns"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               rowKey="username"
               @change="tableChanged">

        <div slot="client" slot-scope="record" :class="loss(record.client_margin) ? 'text-danger': ''">
          <h4>
            <a-icon type="idcard" /> <a :href="routeUri('hyperion.client.show', {client_hash: record.hash})">{{ record.name }}</a>
            <br>
            <a-icon type="user" /> <small><code>{{ record.username }}</code></small>
          </h4>
        </div>

        <div slot="basePrice" slot-scope="record" :class="loss(record.client_margin) ? 'text-danger' : ''">
          <h4><currency :amount="record.product_pricing.price"/></h4>
        </div>
        <div slot="adminFee" slot-scope="record" :class="loss(record.client_margin) ? 'text-danger' : ''">
          <h4><currency :amount="record.product_pricing.admin_fee"/></h4>
        </div>
        <div slot="shareFee" slot-scope="record" :class="loss(record.client_margin) ? 'text-danger' : ''">
          <h4><currency :amount="record.product_pricing.share_fee"/></h4>
        </div>
        <div slot="margin" slot-scope="record" :class="loss(record.client_margin) ? 'text-danger' : ''">
          <h4><currency :amount="record.client_margin"/></h4>
        </div>

        <div slot="expandedRowRender" slot-scope="record">
          <ul>
            <li v-for="biller in record.product_pricing.billers"><h4><code>{{ biller.driver }} : </code> <currency :amount="biller.profit" /></h4></li>
          </ul>
        </div>

        <div slot="action" slot-scope="record">
          <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.client.product', { client_hash: record.hash })"  />
        </div>

      </a-table>
    </a-skeleton>
  </a-card>
</template>

<style scoped>
  .text-danger {
    color: #b1093e;
    font-weight: bold
  }
</style>
